import React from 'react';

/** Fine brow arch with delicate mapping guides — decorative only. */
export function BrowLine({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 240 52" fill="none" aria-hidden="true" className={className} data-id="element-49" data-mp="69ayk8tobz5i">
      <path d="M10 40 C 52 20, 112 8, 160 11 C 192 13, 216 23, 232 36" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" data-id="element-50" data-mp="a78r9lmnl3dn" />
      <path d="M14 44 C 56 28, 112 18, 158 20 C 188 22, 210 30, 226 39" stroke="currentColor" strokeWidth="0.8" strokeLinecap="round" opacity="0.55" data-id="element-51" data-mp="k5wuvfdw5fxt" />
      {[34, 160, 226].map(x => <line key={x} x1={x} y1="2" x2={x} y2="50" stroke="currentColor" strokeWidth="0.7" strokeDasharray="2 3" opacity="0.7" data-id="element-52" data-mp="txkp1o1u1b2z" />)}
      {[[34, 30], [160, 11], [226, 32]].map(([cx, cy]) => <circle key={cx} cx={cx} cy={cy} r="2.2" fill="currentColor" data-id="element-53" data-mp="23r6oskqv1up0" />)}
    </svg>;
}